// components/Registration/RegistrationStepper.js
import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Button } from "@mui/material";
import {
  getdistrictslist,
  getreligionlist,
  getcastelist,
  getcolorlist,
  getstarlist,
  getzodiaclist,
  getdirectionlist,
  getdhosamlist,
  // addregister
} from "../../action/user";
import swal from "sweetalert";
import { toast } from "react-toastify";
import isEmpty from "../../../lib/isEmpty";
import AOS from "aos";
import { useNavigate } from "react-router-dom";
import { addregister } from "../../action/user";

import PersonalDetailsStep from "./PersonalDetailsStep";
import ProfessionDetailsStep from "./ProfessionDetailsStep";
import FamilyDetailsStep from "./FamilyDetailsStep";
import HoroscopeStep from "./HoroscopeStep";
import ContactDetailsStep from "./ContactDetailsStep";

toast.configure();
const toasterOption = {
  position: "bottom center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

// Initial state with ALL fields
const initialFormValue = {
  // Personal details
  phone_number: "",
  mname: "",
  religion: { title: "Hindu", value: "61fe0d29b9938726b92dcb44" },
  subcaste: "",
  height: "",
  educ: "",
  // extra fields
  place_of_birth: "",
  place_of_residence: "",
  self_description: "",
  company_name: "",
  work_sector: "",
  higher_education_qualification: "",
  // kothram: "",
  time_of_birth: "",
  native_place: "",
  dob: "",

  w_place: "",
  different: { title: "No", value: "No" },
  handireason: "",
  bestgod: "",
  date: "",
  month: "",
  year: "",
  sex: "",
  dhosam: "",
  castename: "",
  birth_time: "",
  occup: "",
  income: "",
  children: "",
  child_detail: "",
  colorname: "",
  maritalname: { title: "First Marriage", value: "Marriage" },
  n_marriage: "",
  castenone: "",
  photoshow: "", // profile image (Base64)
  photopath: "",
  // Family details
  father_name: "",
  mother_name: "",
  dad_work: "",
  mom_work: "",
  brother: "",
  m_brother: "",
  sister: "",
  m_sister: "",
  regis: "",
  puriveaam: "",
  livesity: "",
  dever: "",
  peroparty: "",
  pob: "",

  // Horoscope
  starname: "",
  patham: "",
  zodiacname: "",
  gothra: "",
  directionname: "",
  s_year: "",
  s_month: "",
  s_day: "",
  r1: "", r2: "", r3: "", r4: "", r5: "", r6: "",
  r7: "", r8: "", r9: "", r10: "", r11: "", r12: "",
  a1: "", a2: "", a3: "", a4: "", a5: "", a6: "",
  a7: "", a8: "", a9: "", a10: "", a11: "", a12: "",
  // horoscopeImage: "", // uploaded horoscope image (Base64)
  jathgampic:"",

  // Contact
  address: "",
  city: "",
  mobile_number: "",
  email_id: "",
  comment: "",

  // Profession
  // occup: "",
  income: "",
  w_place: "",
  sector: "",
  // company_name: "",

};

export default function RegistrationStepper() {
  const history = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});
  const steps = ["Personal Details", "Profession Details", "Family Details", "Horoscope Details", "Contact Details"];

  const [religions, setReligions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [castes, setCastes] = useState([]);
  const [colors, setColors] = useState([]);
  const [stars, setStars] = useState([]);
  const [zodiacs, setZodiacs] = useState([]);
  const [directions, setDirections] = useState([]);
  const [dhosams, setDhosams] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const r = await getreligionlist();
      const relOpts = r.userValue.map(d => ({ title: d.religion, value: d._id }));
      setReligions(relOpts);
      const d = await getdistrictslist();
      const disOpts = d.userValue.map(d => ({ title: d.city, value: d._id }));
      setDistricts(disOpts);
      const c = await getcastelist(formData.religion.value);
      setCastes(c.userValue.map(d => ({ title: d.castename, value: d._id })));
      const col = await getcolorlist();
      setColors(col.userValue.map(d => ({ title: d.colorname, value: d._id })));
      const st = await getstarlist();
      setStars(st.userValue.map(d => ({ title: d.starname, value: d._id })));
      const zo = await getzodiaclist();
      setZodiacs(zo.userValue.map(d => ({ title: d.zodiacname, value: d._id })));
      const di = await getdirectionlist();
      setDirections(di.userValue.map(d => ({ title: d.directionname, value: d._id })));
      const dh = await getdhosamlist();
      setDhosams(dh.userValue.map(d => ({ title: d.dhosamname, value: d._id })));
      AOS.init({ duration: 2000 });
    };
    fetchData();
  }, []);

  const requiredFields = {
    0: ["phone_number", "mname", "dob", "place_of_birth", "sex", "height", "religion", "castename", "place_of_residence"],
    1: ["occup", "w_place", "income", "work_sector", "company_name", "educ", "higher_education_qualification", "different"],
    2: ["father_name", "mother_name", "dad_work", "mom_work", "brother", "m_brother", "sister", "m_sister", "native_place"],
    3: ["starname", "zodiacname", "dhosam", "directionname", "patham", "gothra"],
    4: ["address", "city", "email_id", "mobile_number"],
  };


  const validateStep = () => {
    const errors = {};
    (requiredFields[activeStep] || []).forEach(field => {
      const val = formData[field];

      if (field === "dob") {
        if (!val || !(val instanceof Date) || isNaN(val.getTime())) {
          errors[field] = "This field is required";
        }
      } else if (field === "time_of_birth") {
        if (!val || !(val instanceof Date) || isNaN(val.getTime())) {
          errors[field] = "This field is required";
        }
      } else if (typeof val === "object" && !Array.isArray(val)) {
        // Autocomplete values (sex, religion, caste)
        if (!val || Object.keys(val).length === 0) {
          errors[field] = "This field is required";
        }
      } else if (!val || val.toString().trim() === "") {
        errors[field] = "This field is required";
      }
    });
    setValidateError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    // setActiveStep(prev => prev + 1);
    if (validateStep()) setActiveStep(prev => prev + 1);
  };

  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleSubmit = async () => {
    console.log('formdata ', formData)
    const payload = {
      ...formData,
      religion: formData.religion?.value,
      castename: formData.castename?.value,
      starname: formData.starname?.value,
      zodiacname: formData.zodiacname?.value,
      dhosam: formData.dhosam?.value,
      directionname: formData.directionname?.value,
      city: formData.city?.value,
      sex: formData.sex?.value,
      maritalname: formData.maritalname?.value,
      // occup: formData.occup?.value,
      income: formData.income?.value,
      patham: formData.patham?.value,
      dob: formData.dob
        ? formData.dob.toISOString().split("T")[0] // YYYY-MM-DD
        : "",
      time_of_birth: formData.time_of_birth ? formData.time_of_birth : "",
      work_sector: formData.work_sector?.value,
      educ: formData.educ?.value,
    };
    console.log('payload ', payload)
    let { error } = await addregister(payload);
    if (isEmpty(error)) {
      toast.success("Registered successfully", toasterOption);
      history("/");
      swal("Registered successfully");
    } else {
      setValidateError(error);
      swal("Please fill in all required fields");
    }
  };

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return <PersonalDetailsStep formData={formData} setFormData={setFormData} validateError={validateError} religions={religions} castes={castes} colors={colors} />;
      case 1:
        return <ProfessionDetailsStep formData={formData} setFormData={setFormData} validateError={validateError} />;
      case 2:
        return <FamilyDetailsStep formData={formData} setFormData={setFormData} validateError={validateError} />;
      case 3:
        return <HoroscopeStep formData={formData} setFormData={setFormData} validateError={validateError} stars={stars} zodiacs={zodiacs} dhosams={dhosams} directions={directions} />;
      case 4:
        return <ContactDetailsStep formData={formData} setFormData={setFormData} validateError={validateError} districts={districts} />;
      default:
        return null;
    }
  };

  return (
    <div style={{ marginTop: '50px' }}>
      {/* Step counter with bigger font */}
      <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: 10, fontSize: "2rem" }}>
        Step {activeStep + 1} of {steps.length}
      </div>

      <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
        {/* Stepper with larger labels */}
        <Stepper activeStep={activeStep} alternativeLabel
          sx={{
            "& .MuiStepConnector-line": {
              borderColor: "#B21919", // Change the connector line color
            },
            "& .MuiStepIcon-root": {
              color: "#B21919", // Default circle color
              "&.Mui-active": {
                color: "#B21919", // Active step circle color
              },
              "&.Mui-completed": {
                color: "#B21919", // Completed step circle color
              },
            },
            "& .MuiStepIcon-text": {
              fontSize: "1.5rem"
            }
          }}
        >
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>
                <span style={{ fontSize: "1.50rem", fontWeight: "600" }}>{label}</span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Form content */}
        <div style={{ marginTop: 40, fontSize: "1.1rem" }}>{renderStep()}</div>

        {/* Navigation buttons - larger */}
        <div style={{ marginTop: 30, display: "flex", justifyContent: "space-between" }}>
          {activeStep !== 0 && (
            <Button
              variant="contained"
              onClick={handleBack}
              style={{
                padding: "12px 24px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                borderRadius: "6px",
                background: "#B21919",
                color: "#FFFFFF"
              }}
            >
              Back
            </Button>
          )}
          {activeStep === steps.length - 1 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              style={{
                padding: "14px 28px",
                fontSize: "1.2rem",
                fontWeight: "bold",
                borderRadius: "6px",
                background: "#B21919",
                color: "#FFFFFF"
              }}
            >
              Submit
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleNext}
              style={{
                padding: "14px 28px",
                fontSize: "1.2rem",
                fontWeight: "bold",
                borderRadius: "6px",
                background: "#B21919",
                color: "#FFFFFF"
              }}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </div>

  );
}
